var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHeaderEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7559 81.5157C64.1083 81.5157 82.2286 63.3954 82.2286 41.043C82.2286 18.6906 64.1083 0.570312 41.7559 0.570312C19.4034 0.570312 1.2832 18.6906 1.2832 41.043C1.2832 63.3954 19.4034 81.5157 41.7559 81.5157Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7556 1.14008C19.718 1.14008 1.85297 19.0051 1.85297 41.0427C1.85297 63.0803 19.718 80.9454 41.7556 80.9454C63.7932 80.9454 81.6582 63.0803 81.6582 41.0427C81.6582 19.0051 63.7932 1.14008 41.7556 1.14008ZM0.712891 41.0427C0.712891 18.3755 19.0883 0 41.7556 0C64.4229 0 82.7983 18.3755 82.7983 41.0427C82.7983 63.71 64.4229 82.0854 41.7556 82.0854C19.0883 82.0854 0.712891 63.71 0.712891 41.0427Z",
    fill: "#0D5CDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_2705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8244 37.9347C55.8244 45.4497 49.7318 51.5529 42.2062 51.5529C34.6805 51.5529 28.5879 45.4603 28.5879 37.9347C28.5879 30.4091 34.6912 24.3164 42.2062 24.3164C49.7211 24.3164 55.8244 30.4091 55.8244 37.9347Z",
    fill: "#4DBFD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4168 37.9359C48.4168 41.3643 45.6358 44.1453 42.2073 44.1453C38.7789 44.1453 35.9979 41.3643 35.9979 37.9359C35.9979 34.5074 38.7789 31.7264 42.2073 31.7264C45.6358 31.7264 48.4168 34.5074 48.4168 37.9359Z",
    fill: "#34495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7644 29.5898C41.1102 29.5898 42.9996 31.4898 42.9996 33.825C42.9996 36.1602 41.0996 38.0601 38.7644 38.0601C36.4293 38.0601 34.5293 36.1602 34.5293 33.825C34.5293 33.7082 34.5293 33.5915 34.5505 33.4747C34.9433 33.6976 35.3997 33.825 35.8773 33.825C37.3633 33.825 38.5734 32.6149 38.5734 31.1289C38.5734 30.577 38.4142 30.0675 38.1276 29.6429C38.3399 29.6111 38.5522 29.5898 38.7644 29.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2086 54.7799C25.5865 54.7799 12.4353 39.527 11.8833 38.8796C11.4269 38.3382 11.4269 37.5421 11.8833 37.0008C12.4353 36.3427 25.5865 21.0898 42.2086 21.0898C58.8308 21.0898 71.9926 36.3427 72.5446 36.9902C73.001 37.5315 73.001 38.3276 72.5446 38.8689C71.9926 39.5164 58.8308 54.7693 42.2086 54.7693V54.7799ZM14.9615 37.9349C18.0821 41.2041 29.2272 51.8716 42.2193 51.8716C55.2113 51.8716 66.367 41.2147 69.477 37.9349C66.367 34.6656 55.2113 23.9982 42.2193 23.9982C29.2272 23.9982 18.0715 34.6656 14.9615 37.9349Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0958 54.174C73.0958 60.1356 70.4852 62.4834 67.2578 62.4834C64.0305 62.4834 61.4199 60.1356 61.4199 54.174C61.4199 48.2124 67.2578 38.0703 67.2578 38.0703C67.2578 38.0703 73.0958 48.2124 73.0958 54.174Z",
    fill: "#E4A162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0357 56.6497C72.0357 58.1168 70.8492 59.3033 69.3821 59.3033C67.915 59.3033 66.7285 58.1168 66.7285 56.6497C66.7285 55.1826 67.915 53.9961 69.3821 53.9961C70.8492 53.9961 72.0357 55.1826 72.0357 56.6497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_2705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.2726,
    height: 55.5559,
    fill: "white",
    transform: "translate(6.98047 14.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHeaderEye);
export default __webpack_public_path__ + "static/media/ico_header_eye.90853dc904eaf521a27a7902f9ee0eae.svg";
export { ForwardRef as ReactComponent };